export function loadingHeroes(arrHeroes){
    return{
        type:'GET_ARR_HEROES',
        payload:arrHeroes
    }
}